// Mock data for the Buddhist organization website

export const heroData = {
  title: "Prabuddha Bharath",
  subtitle: "Journey Towards Enlightened India",
  description: "Following the path shown by Babasaheb Dr. B.R. Ambedkar, embracing Buddhism as the solution to achieve freedom from untouchability and social discrimination.",
  image: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/8xgm2sfm_BUDDHA%20IMAGE.jpg"
};

export const visionMission = {
  vision: {
    title: "Our Vision",
    content: "Prabuddha Bharath - An enlightened India where every individual lives with dignity, equality, and social harmony as envisioned by Babasaheb Dr. B.R. Ambedkar."
  },
  mission: {
    title: "Our Mission",
    activities: [
      "Payback to the society through social welfare programs",
      "Awareness programs on Buddhist philosophy and social equality",
      "Dhamma Sevak education and training",
      "Vipassana Meditation sessions and retreats",
      "Buddhist function organization and celebrations",
      "Buddhist self-help group creation for economic empowerment",
      "Buddhist matrimony service for community welfare",
      "Buddhist entrepreneur help and mentorship",
      "Buddhist conferences for children and women empowerment"
    ]
  }
};

export const ambedkarSection = {
  title: "Babasaheb Dr. B.R. Ambedkar",
  subtitle: "The Architect of Modern India",
  content: "Dr. Bhimrao Ramji Ambedkar, popularly known as Babasaheb, was a jurist, economist, politician and social reformer who inspired the Dalit Buddhist movement and campaigned against social discrimination towards the untouchables. He was the principal architect of the Constitution of India and championed the cause of social equality and justice.",
  quote: "I believe, my people will sacrifice everything to establish Buddhism in India",
  image: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/osoh76p1_Dr._Babasaheb_Ambedkar_12.jpg%20Reverse.jpg"
};

export const pathToSalvation = {
  title: "Path to Salvation",
  subtitle: "Embracing Buddhism as the Only Solution",
  content: "Babasaheb Dr. Ambedkar identified Buddhism as the path to freedom from the shackles of untouchability and caste-based discrimination. On October 14, 1956, he embraced Buddhism along with approximately 500,000 of his followers in Nagpur, marking a historic moment in India's social revolution.",
  principles: [
    {
      title: "Equality",
      description: "Buddhism recognizes all human beings as equal, transcending the barriers of caste, creed, and social status.",
      icon: "scale"
    },
    {
      title: "Liberty",
      description: "Freedom from social bondage and discrimination, enabling individuals to realize their full potential.",
      icon: "bird"
    },
    {
      title: "Fraternity",
      description: "Building a society based on brotherhood, compassion, and mutual respect for all.",
      icon: "users"
    },
    {
      title: "Justice",
      description: "Social, economic, and political justice for all members of society without discrimination.",
      icon: "balance-scale"
    }
  ],
  image: "https://images.unsplash.com/photo-1708508795308-8617bc040ffe"
};

export const buddhaAndDhamma = {
  title: "Buddha and His Dhamma",
  subtitle: "Dr. Ambedkar's Magnum Opus",
  content: "\"The Buddha and His Dhamma\" is Dr. Ambedkar's treatise on Buddha's life and Buddhism. Published posthumously in 1957, this work presents Buddhism as a rational religion and social philosophy. It emphasizes Buddhism's relevance for modern society and its power to transform social structures.",
  keyPoints: [
    "Buddhism as a religion of reason and science",
    "Emphasis on social equality and justice",
    "Rejection of caste system and brahmanical rituals",
    "Path of righteousness through the Noble Eightfold Path",
    "Dhamma as a way of life for social transformation"
  ],
  image: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/jhpt1zv3_714N3siAfvL._SL1000_.jpg"
};

export const revivalOfBuddhism = {
  title: "Revival of Buddhism",
  subtitle: "Following Ambedkar's Blueprint",
  content: "Our organization is dedicated to the revival of Buddhism in India as per the blueprint laid down by Babasaheb Dr. Ambedkar. We work towards creating a society based on Buddhist principles of compassion, equality, and social justice.",
  initiatives: [
    {
      title: "Dhamma Education",
      description: "Teaching Buddhist philosophy and principles to people of all ages",
      image: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/mufn9fj8_Dhamma%20sevak%20.jpeg"
    },
    {
      title: "Vipassana Meditation",
      description: "Organizing meditation sessions and retreats for mental peace and self-realization",
      image: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/al8hd28l_Vipasana%20Medit.jpg"
    },
    {
      title: "Buddhist Conferences",
      description: "Conducting conferences for children, women, and youth on Buddhist values - CHIBUCON 2025",
      image: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/ih7ht4lq_CHIBUCON%202025.jpeg"
    },
    {
      title: "Self-Help Groups",
      description: "Creating Buddhist self-help groups for economic empowerment and social welfare",
      image: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/wxnw583r_Self%20help%20groups.jpg"
    },
    {
      title: "Matrimony Service",
      description: "Facilitating Buddhist matrimony services for community welfare",
      image: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/vxdl8f58_Budh%20Mat%201.jpg"
    },
    {
      title: "Entrepreneur Support",
      description: "Providing help and mentorship to Buddhist entrepreneurs",
      image: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/vygcavzc_IADF.jpg"
    }
  ]
};

export const contactInfo = {
  phone: "9443797174",
  email: "president@mmtorg.in",
  volunteerFormUrl: "https://docs.google.com/forms/d/1_H4zDoA2q7qoHv0dHK7UvKpDyzzesLpHw9-VVNHK_s8/viewform",
  address: "No: 71, Astalakshmi Nagar, Ellakudi, Kattur, Trichy 620019",
  registration: "199/2018",
  socialMedia: {
    facebook: "#",
    twitter: "#",
    instagram: "#",
    youtube: "https://www.youtube.com/@mmtglobal1024"
  }
};

export const donationInfo = {
  upiId: "massmovement@sbi",
  qrCode: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/0jm51qfu_UPI%20ID%20QR%20CODE.jpeg",
  bankDetails: {
    bankName: "State Bank of India",
    accountName: "Mass Movement for Transformation",
    accountNumber: "38026456281",
    ifscCode: "SBIN0007487",
    branch: "Ramalinga Nagar, Tiruchii"
  }
};

export const buddhismBenefits = {
  title: "Why Buddhism?",
  benefits: [
    {
      icon: "heart",
      title: "Compassion",
      description: "Buddhism teaches universal compassion and loving-kindness towards all beings."
    },
    {
      icon: "brain",
      title: "Wisdom",
      description: "Developing wisdom through understanding the true nature of reality and existence."
    },
    {
      icon: "flower",
      title: "Peace",
      description: "Achieving inner peace through meditation and mindful living."
    },
    {
      icon: "users",
      title: "Social Harmony",
      description: "Building a society based on equality, respect, and mutual understanding."
    }
  ]
};
